import script from "./PayChannelView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayChannelView.vue?vue&type=script&lang=ts&setup=true"

import "./PayChannelView.vue?vue&type=style&index=0&id=7530f604&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7530f604"]])

export default __exports__